import script from "./AddValue.vue?vue&type=script&setup=true&lang=js"
export * from "./AddValue.vue?vue&type=script&setup=true&lang=js"

import "./AddValue.vue?vue&type=style&index=0&id=6a04df94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a04df94"]])

export default __exports__